const STORAGE_KEY = "wasteSortingLeaderboard";

export const loadScores = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const saveScores = (scores) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
  } catch {
    // ignore
  }
};

export const addScoreToLeaderboard = (game, type, score, name) => {
  if (!game || !type || score <= 0) return [];
  const allScores = loadScores();
  const newEntry = {
    game,
    type,
    score,
    name: name || "Player",
    date: new Date().toLocaleDateString(),
    id: Date.now(),
  };
  allScores.push(newEntry);
  // Keep only top 10 per game+type
  const filtered = allScores
    .filter((s) => s.game === game && s.type === type)
    .sort((a, b) => b.score - a.score)
    .slice(0, 10);
  const otherEntries = allScores.filter(
    (s) => !(s.game === game && s.type === type)
  );
  const newScores = [...otherEntries, ...filtered];
  saveScores(newScores);
  return filtered;
};